import React from "react";

import type { MediaItem } from "../../media-widget/types/contexts";
import { usePlaylist } from "../../media-widget/hooks/usePlaylistContext";

interface MediaDescriptionProps {
  media: MediaItem;
}

const MediaDescription: React.FC<MediaDescriptionProps> = ({ media }) => {
  const { isDescriptionExpanded, setIsDescriptionExpanded } = usePlaylist();

  // Don't render anything if there's no title or description
  if (!media.title && !media.description) {
    return null;
  }

  // Don't render for website type
  if (media.type === "website") {
    return null;
  }

  return (
    <div className="w-full min-w-0 bg-white text-foreground">
      <div className="p-4">
        <h2 className="mb-2 text-xl font-bold sm:text-2xl">{media.title}</h2>
        <p className={`max-w-[400px]text-sm text-wrap marker:text-gray-300`}>
          {!isDescriptionExpanded
            ? media.description.slice(0, 100)
            : media.description}
        </p>
        {media.description.length > 100 && (
          <button
            onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
            className="mt-1 text-sm hover:text-primary"
          >
            {isDescriptionExpanded ? "Show less" : "Read more"}
          </button>
        )}
      </div>
    </div>
  );
};

export default MediaDescription;
